import { object } from 'common/helpers'


export const initialState = {
  location: {
    pathname: null,
    search: null,
    query: {},
  },
  prevLocation: {
    pathname: null,
    search: null,
    query: {},
  },
}

export default (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case '@@router/LOCATION_CHANGE': {
      const query = {}

      if (payload.location && payload.location.search && payload.location.search.length > 0) {
        payload.location.search
          .substring(1)
          .split('&')
          .forEach((queryString) => {
            const [ key, queryValue ] = queryString.split('=')
            let value = decodeURIComponent(queryValue)

            try {
              query[key] = JSON.parse(value)
            }
            catch (e) {
              query[key] = value
            }
          })
      }

      const newState = object.setIn(payload, [ 'location', 'query' ], query)
      const prevLocation = payload.isFirstRendering ? initialState.prevLocation : state.location

      return object.setIn(newState, [ 'prevLocation' ], prevLocation)
    }
    default:
      return state
  }
}
